// extracted by mini-css-extract-plugin
module.exports = {"subheader1":"Subheader_subheader1__3GPhP","subheader2":"Subheader_subheader2__3A5Dd"};